import { PROPERTY_TYPE_TRANSLATIONS } from '#shared/property/url-referential';

export default defineNuxtRouteMiddleware((to, _from) => {
  const cleanedPathFr = to.fullPath
    .replace('biens-a-usage-commercial', PROPERTY_TYPE_TRANSLATIONS.business.fr)
    .replace('shop-premises-commercial', PROPERTY_TYPE_TRANSLATIONS.business.en);
  if (to.fullPath !== cleanedPathFr) {
    return navigateTo(cleanedPathFr, {
      redirectCode: 301,
      replace: true,
    });
  }
});
